import {Stack, Typography, Button} from '@mui/material';
import {IconIllustration, CTAButtonFixed} from 'presentation/components';
import React from 'react';
import {FacialBiometricsHeader} from '../../components/FacialBiometricsHeader';
import {ResponsiveCard} from '../../components/ResponsiveCard';

import {translations} from 'presentation/translations-new';
import {useSuccessPage} from './hooks/useSuccessPage';

const {secondaryAction, title, registerAnotherGuardian} =
	translations['pt-br'].others.facialBiometric.success;

export function Success() {
	const {
		isTablet,
		handleGoToHome,
		handleGo,
		handleRegisterAnotherGuardian,
		primaryAction,
		showSecondaryAction,
		showRegisterAnotherGuardian,
	} = useSuccessPage();

	return (
		<>
			<FacialBiometricsHeader />
			<Stack alignItems="center" height="100%">
				<ResponsiveCard>
					<Stack
						alignItems="center"
						gap={2}
						textAlign="center"
						justifyContent="center"
						height="100%"
						p={8}>
						<IconIllustration
							variant="success"
							customIconName="check-circle-outline-filled"
						/>
						<Typography variant="h6">{title}</Typography>

						{!isTablet && (
							<Stack direction="row" gap={1} mt={8}>
								{showRegisterAnotherGuardian && (
									<Button onClick={handleRegisterAnotherGuardian}>
										{registerAnotherGuardian}
									</Button>
								)}
								{showSecondaryAction && (
									<Button onClick={handleGoToHome} variant="outlined">
										{secondaryAction}
									</Button>
								)}
								{!showRegisterAnotherGuardian && (
									<Button onClick={handleGo}>{primaryAction}</Button>
								)}
							</Stack>
						)}
					</Stack>
				</ResponsiveCard>

				{isTablet ? (
					<CTAButtonFixed.Root $isTablet={isTablet} sx={{bottom: 0}}>
						{showRegisterAnotherGuardian ? (
							<CTAButtonFixed.Action
								onClick={handleRegisterAnotherGuardian}
								fullWidth>
								{registerAnotherGuardian}
							</CTAButtonFixed.Action>
						) : (
							<CTAButtonFixed.Action onClick={handleGo} fullWidth>
								{primaryAction}
							</CTAButtonFixed.Action>
						)}
						{showSecondaryAction && (
							<CTAButtonFixed.Action
								onClick={handleGoToHome}
								variant="outlined"
								fullWidth>
								{secondaryAction}
							</CTAButtonFixed.Action>
						)}
					</CTAButtonFixed.Root>
				) : null}
			</Stack>
		</>
	);
}
